module.exports = __webpack_public_path__ + "img/municipal.0c957101.png";